import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

const _sharedTabClasses: string = buildCssClassName(
    "pt-[15px]",
    "md:pt-[40px]",
    "px-[15px]",
    "md:px-[30px]",
    "lg:px-[80px]",
    "pb-[100px]",
    "self-center",
    "md:max-w-[calc(800px+60px)]",
    "lg:max-w-[calc(800px+160px)]"
)

export default {
    page: {
        error: (): string => "mx-auto !mt-[5%]"
    },
    modulesTab: {
        container: (): string =>
            buildCssClassName("flex flex-col md:max-w-[800px] w-full gap-y-[50px]", _sharedTabClasses),
        heading: ({ isLoaded }: { isLoaded: boolean }): string =>
            buildCssClassName("flex flex-col gap-y-[20px]", { "[pointer-event:none]": !isLoaded }),
        stepper: ({ isLoading }: { isLoading: boolean }): string =>
            buildCssClassName(
                { "opacity-50 grayscale contrast-75 [pointer-events:none]": isLoading, "opacity-[1]": !isLoading },
                getTransitionTwClasses("all", 200)
            ),
        emptyHint: (): string => "mt-0 mb-auto py-[10px] px-[15px] bg-blue-600 rounded-[5px] w-full md:max-w-[800px]",
        unassignedContainer: (): string => "flex flex-col w-full gap-[20px]",
        navigationContainer: (): string =>
            "py-[20px] px-[20px] flex items-center justify-between border-t-[1px] border-t-blue-500",
        navigationWrapper: (): string =>
            "pl-[10px] flex gap-x-[10px] items-baseline justify-between group !outline-none",
        navigationText: (): string => "flex flex-col items-end",
        navigationArrow: (): string =>
            buildCssClassName(
                "flex",
                "items-center",
                "justify-center",
                "mt-[3px]",
                "w-[20px]",
                "h-[20px]",
                "rounded-full",
                "border-[1px]",
                "border-blue-300",
                "hover:border-blue-200",
                "focus-visible:border-blue-200",
                "group-hover:border-blue-200",
                "group-focus-visible:border-blue-200",
                "bg-white",
                "hover:bg-blue-600",
                "focus-visible:bg-blue-600",
                "group-hover:bg-blue-600",
                "group-focus-visible:bg-blue-600",
                getTransitionTwClasses("all", 200)
            ),
        phaseContainer: (): string => "flex flex-col gap-y-[10px]",
        phaseTitleWrapper: (): string => "flex flex-col gap-y-[5px]",
        phaseValue: (): string => "py-[3px] px-[5px] rounded-[5px] bg-gray-500 w-fit",
        chatsWrapper: (): string => "flex flex-col px-[5px]",
        chatWrapper: (): string => "mb-[40px] px-[10px]",
        chatTitle: (): string => "pt-[20px] px-[15px] flex items-baseline gap-x-[10px]",
        chatHolder: ({ isReady }: { isReady: boolean }): string =>
            buildCssClassName("flex flex-col gap-y-[20px]", [
                { "contrast-100 brightness-100": isReady },
                { "contrast-50 brightness-75": !isReady },
                getTransitionTwClasses("all", 500)
            ])
    },
    diagnosticTab: {
        container: (): string => buildCssClassName("md:max-w-[800px]", _sharedTabClasses),
        emptyHint: (): string => "mt-[40px] mb-auto py-[10px] px-[15px] bg-blue-600 rounded-[5px] w-full"
    },
    sessionsTab: {
        container: (): string => buildCssClassName("md:max-w-[800px]", "max-[767px]:mt-[10px]", _sharedTabClasses)
    }
}
